import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  getParcel,
  ParcelDataResponse,
} from '@/endpoints/itasca/parcels/getParcel';
import { setContent as setToastContent } from '@/redux/slices/toastSlice';
import Logger from '@/utils/logger';

export const useParcelDetails = (
  passedClip: undefined | string | null = undefined,
  usePassedClip: boolean = false
) => {
  const dispatch = useDispatch();
  const [parcel, setParcel] = useState<null | ParcelDataResponse>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchParcel = useCallback(
    async (clipId: string | undefined | null) => {
      if (!clipId) return;

      try {
        setIsLoading(true);
        const { res, err } = await getParcel({ clip: clipId });

        if (err) throw new Error(err.message);

        if (res) {
          setParcel(res.data);
        }
      } catch (err) {
        Logger.error(err);
        dispatch(
          setToastContent({
            action: undefined,
            show: true,
            text: 'Failed to fetch parcel details',
            type: 'dismiss',
          })
        );
      } finally {
        setIsLoading(false);
      }
    },
    [dispatch]
  );

  useEffect(() => {
    if (!passedClip) return;

    fetchParcel(passedClip);
  }, [fetchParcel, passedClip, usePassedClip]);

  return { isLoading, parcel };
};
